import { EnvelopeClosedIcon, LinkedInLogoIcon } from '@radix-ui/react-icons'
import { Phone } from 'phosphor-react'
import { useIntl } from 'react-intl'
import { Link } from 'react-router-dom'
import logoWhite from '../../../../assets/svgs/logoWhite.svg'

export const Footer = () => {
  const { formatMessage } = useIntl()

  return (
    <footer className="bg-[#001D2F] text-xs leading-[18px] text-white min-h-[294px] h-full">
      <div className="flex flex-col items-center justify-between py-8 h-full">
        <div className="flex flex-col md:flex-row flex-wrap items-start justify-between px-4 gap-y-8 mx-auto font-normal text-white uppercase max-w-7xl w-full">
          <img
            src={logoWhite}
            className="w-24 lg:w-[134px]"
          />
          <div className="grid grid-cols-3 sm:grid-cols-5 h-full gap-x-6 xl:gap-x-14 gap-y-4 max-w-2xl">
            <div>
              <p className="font-semibold">{formatMessage({ id: 'ABOUT_US' })}</p>
            </div>
            <div>
              <p className="font-semibold">{formatMessage({ id: 'WHY_US' })}</p>
            </div>
            <div>
              <p className="mb-3 font-semibold">{formatMessage({ id: 'EXPERT' })}</p>
              <Link to="/expert"><p>{formatMessage({ id: 'REGISTER' })}</p></Link>
            </div>
            <div>
              <p className="mb-3 font-semibold">{formatMessage({ id: 'CLIENT' })}</p>
              <Link to="/contact-us"><p>{formatMessage({ id: 'CONTACT_US' })}</p></Link>
            </div>
            <div>
              <p className="mb-3 font-semibold">{formatMessage({ id: 'COMPLIANCE' })}</p>
              <Link to="/privacy-policy"><p className="mb-3">{formatMessage({ id: 'PRIVACY_POLICY' })}</p></Link>
              <Link to="/terms-of-use"><p className="mb-3">{formatMessage({ id: 'TERMS_OF_USE' })}</p></Link>
              <Link to="/terms-of-participation"><p>{formatMessage({ id: 'TERMS_OF_PARTICIPATION' })}</p></Link>
            </div>
          </div>
          <div className="font-semibold">
            <h1 className="mb-4">{formatMessage({ id: 'CONTACT' })}</h1>
            <p className="mb-2">{formatMessage({ id: 'E_MAIL' })}</p>
            <div className='flex mb-4'>
              <EnvelopeClosedIcon className="w-4 h-4 mr-2" />
              <p>
                contato@trustinsight.com.br
              </p>
            </div>
            <p className="mb-2">{formatMessage({ id: 'PHONE' })}</p>
            <div className='flex mb-[34px]'>
              <Phone className="w-4 h-4 mr-2" />
              <p>
                +55 11 3539-3292
              </p>
            </div>
            <a href="https://www.linkedin.com/company/trust-insight/" target='_blank' rel="noreferrer">
              <LinkedInLogoIcon className="w-10 h-10" />
            </a>
          </div>
        </div>
        <div>
          <p>
            {formatMessage({ id: 'ALL_RIGHTS_RESERVED' })}
          </p>
        </div>
      </div>
    </footer>
  )
}
